import styled from 'styled-components';
import { Button } from '../../../components/utils/Button/Button';

export const Container = styled.div`
  height: 100%;
  background: #f9fafb;
`;

export const StyledButton = styled(Button)`
  width: unset;
  height: 3.4rem;
  font-size: 1.4rem;
  padding-inline: 1.6rem;
  border-radius: 12px;
`;
